@if (changeCategoriesFilteredAndSorted.length > 0) {
  <div
    [ngClass]="{'py-[.4rem]' : verticalOrientation}">
    <mat-chip-set role="list" aria-label="Kategorien der Programmänderung" class="is-small" [tabIndex]="-1"
                  [ngClass]="{'mat-mdc-chip-set-stacked' : verticalOrientation}">
      @for (changeCat of changeCategoriesFilteredAndSorted; track changeCat) {
        <mat-chip role="listitem"
                  [ngClass]="{'!my-[.125rem] !w-auto' : verticalOrientation}">
          <div class="flex">
            @if ((changeCat.toLowerCase() === categoryValues.statutoryLowerCase)) {
              <img class="change-category-image high-contrast-for-dark-image"
                  ngSrc="./assets/images/sli-gesetzlich-18.svg" alt="" height="18" width="18">
            }
            @if ((changeCat.toLowerCase() === categoryValues.functionalLowerCase)) {
              <img class="change-category-image high-contrast-for-dark-image"
                  ngSrc="./assets/images/sli-funktional-18.svg" alt="" height="18" width="18">
            }
            @if ((changeCat.toLowerCase() === categoryValues.bugfixLowerCase)) {
              <img class="change-category-image high-contrast-for-dark-image"
                  ngSrc="./assets/images/sli-fehlerbehebung-18.svg" alt="" height="18" width="18">
            }
            @if ((changeCat.toLowerCase() === categoryValues.technicalLowerCase)) {
              <img class="change-category-image high-contrast-for-dark-image"
                  ngSrc="./assets/images/sli-technisch-18.svg" alt="" height="18" width="18">
            }
            {{ changeCat | changeCategory }}
          </div>
        </mat-chip>
      }
    </mat-chip-set>
  </div>
}
